module.exports = new __parcel__URL__("foster-provost.f120808b.jpeg").toString();